import Marquee from "react-fast-marquee";
import { TrendUp } from "@phosphor-icons/react";

export default function GoldRateTicker({ rates }) {
  const items = [
    { label: "22K Gold", value: rates?.["22k"] ?? 6600, unit: "/g" },
    { label: "24K Gold", value: rates?.["24k"] ?? 7200, unit: "/g" },
    { label: "18K Gold", value: rates?.["18k"] ?? 5400, unit: "/g" },
    { label: "Silver", value: rates?.silver ?? 95, unit: "/g" },
  ];
  const display = [...items, ...items, ...items];

  return (
    <div className="ticker-bg py-3" data-testid="gold-rate-ticker">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center gap-4">
        <div className="hidden sm:flex items-center gap-2 shrink-0 text-[#3B5BDB]">
          <TrendUp size={18} weight="duotone" />
          <span className="text-xs uppercase tracking-[0.2em] font-semibold whitespace-nowrap">
            Board Rate · City Wise
          </span>
        </div>
        <Marquee gradient={false} speed={40} pauseOnHover>
          {display.map((it, i) => (
            <div
              key={i}
              className="flex items-baseline gap-2 mx-8 whitespace-nowrap"
            >
              <span className="text-sm text-[#4A5568]">{it.label}</span>
              <span className="font-display text-lg font-semibold text-[#0A1128]">
                ₹{it.value.toLocaleString("en-IN")}
              </span>
              <span className="text-xs text-[#4A5568]">{it.unit}</span>
              <span className="text-[#D4AF37]">·</span>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
